import { FC, ReactNode } from 'react'
import { KeyboardAvoidingView, StyleSheet, View } from 'react-native'

interface PaddingKeyboardAvoiderProps {
    children: ReactNode
    keyboardVerticalOffset?: number
}

const PaddingKeyboardAvoider: FC<PaddingKeyboardAvoiderProps> = ({
    children,
    keyboardVerticalOffset = 0,
}) => {
    return (
        <KeyboardAvoidingView
            behavior="padding"
            keyboardVerticalOffset={keyboardVerticalOffset}
            style={styles.container}
        >
            <View style={styles.content}>{children}</View>
        </KeyboardAvoidingView>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        width: '100%',
    },
    content: {
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
    },
})

export default PaddingKeyboardAvoider
